module.exports = __webpack_public_path__ + "static/img/xte.2754085.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xte.png
// module id = n9Fz
// module chunks = 0